import { IDs } from '../../../helpers/IDs';
import { Kennzahl } from './Kennzahl';

export function calculateKennzahlenStrukturiert(data: any)  {
    const start = new Date().getTime();
    calculateKennzahlenStrukturiertGesamt(data); // Zusammenrechnen von Kennzahlen, z.B. alle Energieträger in Wärme
    calculateKennzahlenStrukturiertSummen(data); // SUMMIEREN FÜR GESAMT (ggf. später auch Gruppen)
    const end  = new Date().getTime();
    // console.log('calculateKennzahlenStrukturiert-Duration: ', (end - start));
}

function calculateKennzahlenStrukturiertGesamt(data: any)  {
    const kennziffern_strukturiert = data[IDs.KENNZIFFERN_STRUKTURIERT];
    Object.keys(kennziffern_strukturiert).forEach((jahr: string) => {
        const jahr_daten = kennziffern_strukturiert[jahr];
        Object.keys(jahr_daten).forEach((standort_tid: string) => {
            const kennzahlen = jahr_daten[standort_tid];
            Object.keys(kennzahlen).forEach((kennzahl_key: string) => {
                const kenn_obj: Kennzahl = kennzahlen[kennzahl_key];
                if ([Kennzahl.TYPE_MAX, Kennzahl.TYPE_SUMME].indexOf(kenn_obj.getType()) !== -1) {
                    if (!kenn_obj.hasItems()) {
                        delete kennzahlen[kennzahl_key];
                        return;
                    }
                } else if (kenn_obj.isNull()) {
                    delete kennzahlen[kennzahl_key];
                    return;
                }
                if (kenn_obj.getGesamt()) {
                    const gesamt_key = `${kenn_obj.getGesamt()}_${kenn_obj.getField()}`;
                    if (!kennzahlen[gesamt_key]) {
                        kennzahlen[gesamt_key] = kenn_obj.clone();
                        kennzahlen[gesamt_key]
                            .setKey(kenn_obj.getGesamt())
                            .setName(kenn_obj.getGesamtName())
                            .delAttribute('gesamt')
                            .delAttribute('gesamtName');
                        kenn_obj.delAttribute('gesamtName');
                    } else {
                        const kenn_ges: Kennzahl = kennzahlen[gesamt_key];
                        kenn_ges.addKennzahl(kenn_obj);
                    }
                }
            });
        });
    });
}

function calculateKennzahlenStrukturiertSummen(data: any)  {
    const kennziffern_strukturiert = data[IDs.KENNZIFFERN_STRUKTURIERT];
    Object.keys(kennziffern_strukturiert).forEach((jahr: string) => {
        const jahr_daten = kennziffern_strukturiert[jahr];
        Object.keys(jahr_daten).forEach((standort_tid: string) => {
            if (standort_tid === 'ALL') { return; }
            if (!jahr_daten['ALL']) {
                jahr_daten['ALL'] = {};
            }
            const kennzahlen = jahr_daten[standort_tid];
            // console.log('calculateKennzahlenStrukturiert: ', jahr, standort_tid, kennzahlen);
            Object.keys(kennzahlen).forEach((kennzahl_key: string) => {
                // Wir gehen erstmal davon aus, dass Kennzahlen auf dieser Ebene summierbar sind
                // ggf. noch nach Typ Summe prüfen?
                const kenn_obj: Kennzahl = kennzahlen[kennzahl_key];
                if (!jahr_daten['ALL'][kennzahl_key]) {
                    jahr_daten['ALL'][kennzahl_key] = kenn_obj.clone();
                } else {
                    const kenn_all: Kennzahl = jahr_daten['ALL'][kennzahl_key];
                    kenn_all.addKennzahl(kenn_obj);
                }
            });
        });
    });
}

function calculateKennzahlenStrukturiertWerte(data: any)  {
    const kennziffern_strukturiert = data[IDs.KENNZIFFERN_STRUKTURIERT];
    Object.keys(kennziffern_strukturiert).forEach((jahr: string) => {
        const jahr_daten = kennziffern_strukturiert[jahr];
        Object.keys(jahr_daten).forEach((standort_tid: string) => {

        });
    });
}
